import { Component, OnInit, Input, Output, OnChanges, ViewChild, EventEmitter, ElementRef } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SettingsService } from 'src/app/services/settings.service';
import { SystemService } from 'src/app/services/system.service';
import { UserService } from 'src/app/services/user.service';
import { Error } from 'src/app/shared/models/general/error';
import { QueueNotification } from 'src/app/shared/models/users/queue-notification';
import { UserBasicDetails } from 'src/app/shared/models/users/user-basic-details';
import { UserBilling } from 'src/app/shared/models/users/user-billing';
import { UserFullDetails } from 'src/app/shared/models/users/user-full-details';
import { UserProfile } from 'src/app/shared/models/users/user-profile';
import { UserSearchResult } from 'src/app/shared/models/users/user-search-result';
import { UserTradingBankAccount } from 'src/app/shared/models/users/user-trading-bank-account';
import { Users } from 'src/app/shared/models/users/users';
import { UsersSearchRequest } from 'src/app/shared/models/users/users-search-request';
import { TagsService } from 'src/app/services/tags.service';
import { getEmailRegExpression } from 'src/app/utils/utils.common';
import { UserIdentifiers } from 'src/app/shared/models/users/user-identifiers';

@Component({
  selector: 'app-user-profile-modal',
  templateUrl: './user-profile-modal.component.html',
  styleUrls: ['./user-profile-modal.component.scss'],
})
export class UserProfileModalComponent implements OnInit, OnChanges {
  @ViewChild('userInfoModal', { static: true }) userInfoModal: any;

  @Input() selectedUserDetails: UserFullDetails;
  @Input() showModal: boolean = false;
  @Output() showModalChange = new EventEmitter<boolean>();
  @Output() onModelChange = new EventEmitter<UserFullDetails>();

  busy: boolean = false;
  editSpouseBusy: boolean = false;
  showError: boolean = false;
  errorMsg: string = '';
  formInvalid: boolean = false;
  idNumberInUse: boolean = false;
  currentTab: string = 'profile';

  statusResendRegistrationEmail: boolean = true;
  showResendRegistrationEmailMessage: boolean = false;
  resultResendRegistrationEmail: string = '';
  lastRegistrationNotificationSent = new QueueNotification();

  user: Users = new Users();
  spouse: UserBasicDetails = new UserBasicDetails();
  userProfile: UserProfile = new UserProfile();
  userBilling: UserBilling = new UserBilling();
  userIdentifiers: UserIdentifiers = new UserIdentifiers();

  userTradingBankAccount: UserTradingBankAccount = new UserTradingBankAccount();

  editSpouse: boolean = false;
  spouseSearchRequest: UsersSearchRequest = new UsersSearchRequest();
  spouseSearchResults: UserSearchResult[] = [];

  systemDefaultPips: number = 0;

  regexForEmail = getEmailRegExpression();

  usersBillingDropdown: { Id: number; Name: string }[] = [
    { Id: 1, Name: 'Standard' },
    { Id: 2, Name: 'Premium' },
  ];

  YesNoDropdown: { Value: boolean; Name: string }[] = [
    { Value: true, Name: 'Yes' },
    { Value: false, Name: 'No' },
  ];

  constructor(
    public settingsService: SettingsService,
    public usersService: UserService,
    public activeModal: NgbActiveModal,
    public systemService: SystemService,
    private el: ElementRef,
    private tagService: TagsService
  ) {
    this.GetSystemDefaultPips();
  }

  ngOnInit(): void {}

  ngOnChanges(): void {
    this.showHideModal(null);
    this.idNumberInUse = false;

    if (this.showModal) {
      this.setUserIdentifiers();
    }
  }

  private setUserIdentifiers() {
    this.userIdentifiers.idNumber = this.userProfile.idNumber;
    this.userIdentifiers.userId = this.userProfile.userId;
    this.userIdentifiers.taxNumber = this.userProfile.incomeTaxReferenceNumber;
  }

  onClosed(event: any) {
    if (this.showModal != false) {
      this.showModal = false;
      this.showModalChange.emit(this.showModal);
    }
  }

  showHideModal(toggle: boolean | null) {
    if (toggle != null) {
      this.showModal = toggle;
    }

    if (this.showModal) {
      this.clearErrors();
      this.userInfoModal.show();
      this.currentTab = 'profile';

      this.user = this.selectedUserDetails?.user ? JSON.parse(JSON.stringify(this.selectedUserDetails.user)) : new Users();

      this.spouse = this.selectedUserDetails?.spouse ? JSON.parse(JSON.stringify(this.selectedUserDetails.spouse)) : new UserBasicDetails();

      this.userProfile = this.selectedUserDetails?.profile
        ? JSON.parse(JSON.stringify(this.selectedUserDetails.profile))
        : new UserProfile();

      this.userBilling = this.user.userBilling?.[0] ? JSON.parse(JSON.stringify(this.user.userBilling[0])) : new UserBilling();

      this.userTradingBankAccount = this.user.userTradingBankAccounts?.[0]
        ? JSON.parse(JSON.stringify(this.user.userTradingBankAccounts[0]))
        : new UserTradingBankAccount();

      this.GetLastRegisterNotification();
    } else if (!this.showModal) {
      // Blur any focused element before hiding modal to prevent aria-hidden warning
      if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
      }
      this.selectedUserDetails = new UserFullDetails();
      this.user = new Users();
      this.userProfile = new UserProfile();
      this.userBilling = new UserBilling();
      this.userTradingBankAccount = new UserTradingBankAccount();
      this.spouseSearchRequest = new UsersSearchRequest();
      this.spouseSearchResults = [];
      this.userInfoModal.hide();
    }

    this.showModalChange.emit(this.showModal);
  }

  GetLastRegisterNotification() {
    this.lastRegistrationNotificationSent = new QueueNotification();
    var lastNotification = new QueueNotification();
    if (this.selectedUserDetails.queueNotifications.length > 0) {
      this.selectedUserDetails.queueNotifications
        .filter((x) => x.notificationType == 'RegistrationIndividualConfirmation')
        .forEach((notification) => {
          if (lastNotification.updatedDate == null || lastNotification.createdDate < notification.createdDate) {
            lastNotification = notification;
          }
        });
    }
    this.lastRegistrationNotificationSent = lastNotification;
  }

  EditSpouse() {
    this.editSpouse = true;
  }

  RemoveSpouse() {
    this.spouse = new UserBasicDetails();
    this.editSpouse = false;
    this.spouseSearchRequest = new UsersSearchRequest();
    this.spouseSearchResults = [];
  }

  AssignSpouse(selectedUser: UserSearchResult) {
    this.spouse = new UserBasicDetails();
    this.spouse.id = selectedUser.id;
    this.spouse.fullName = selectedUser.fullName;
    this.editSpouse = false;
    this.spouseSearchRequest = new UsersSearchRequest();
    this.spouseSearchResults = [];
  }

  SearchSpouse() {
    this.clearErrors();
    this.editSpouseBusy = true;
    this.editSpouse = true;
    this.spouseSearchRequest.entityType = this.settingsService.brokerEntity.id;
    this.spouseSearchRequest.entityId = this.settingsService.brokerUsers[0].brokerId;

    this.usersService.SearchUsers(this.spouseSearchRequest).subscribe(
      (response) => {
        this.spouseSearchResults = response;
        this.showError = false;
        this.editSpouseBusy = false;
      },
      (error) => {
        this.editSpouseBusy = false;
        this.showError = true;
        this.errorMsg = error.error.ErrorDetail;
      }
    );
  }

  resendRegistrationEmail() {
    this.clearErrors();
    this.busy = true;
    this.showResendRegistrationEmailMessage = false;

    let userId: number = this.selectedUserDetails.user.id;
    this.usersService.ResendRegistrationEmail(userId).subscribe(
      () => {
        this.busy = false;
        this.showResendRegistrationEmailMessage = true;
        this.resultResendRegistrationEmail = 'Successfully Queued Registration Email';
      },
      (error) => {
        this.busy = false;
        this.showError = true;
        var errorMessage = 'Failed to Queue Email';
        if (error.status == 500) {
          errorMessage += ': Server Error';
        } else if (error.error?.ErrorDetail) {
          errorMessage += ': ' + error.error.ErrorDetail;
        }
        this.errorMsg = errorMessage;
      }
    );
  }
  private scrollToFirstInvalidControl() {
    const firstInvalidControl: HTMLElement = this.el.nativeElement.querySelector('form .ng-invalid');

    firstInvalidControl.focus(); //without smooth behavior
  }

  //Update user profile
  saveClicked(form: NgForm) {
    // stop here if form is invalid
    this.formInvalid = form.invalid || this.idNumberInUse || this.isTradingPausedReasonMissing();
    if (this.formInvalid) {
      form.form.markAllAsTouched();
      this.scrollToFirstInvalidControl();
      return;
    }
    this.busy = true;
    this.clearErrors();

    this.selectedUserDetails.user = this.user;
    this.selectedUserDetails.spouse = this.spouse;

    this.selectedUserDetails.user.userBilling = [];
    this.selectedUserDetails.user.userBilling.push(this.userBilling);

    this.selectedUserDetails.user.userTradingBankAccounts = [];
    this.selectedUserDetails.user.userTradingBankAccounts.push(this.userTradingBankAccount);

    this.selectedUserDetails.profile = this.userProfile;
    this.usersService.UserProfileUpdate(this.selectedUserDetails).subscribe({
      next: () => {
        this.busy = false;
        this.onModelChange.emit(this.selectedUserDetails);
        this.tagService.refreshNeeded$.next(this.selectedUserDetails.user.id);
        this.showHideModal(false);
      },
      error: (error) => {
        this.parseAndDisplayError(error);
        return;
      },
    });
  }

  parseAndDisplayError(error: any) {
    this.errorMsg = Error.InterpretErrorMessage(error);
    this.showError = true;
    this.busy = false;
  }

  clearErrors() {
    this.errorMsg = '';
    this.showError = false;
  }

  GetSystemDefaultPips() {
    this.systemService.GetSystemSetting('AppSettings', 'DefaultPips').subscribe(
      (response) => {
        this.systemDefaultPips = parseFloat(response.value);
      },
      (error) => {
        this.systemDefaultPips = -1;
        console.log('get system default pips error', error);
      }
    );
  }

  CheckIfIdInUse() {
    if (this.shouldCheckIdNumber() === false) {
      return;
    }
    this.usersService.GetIdNumberInUse(this.userProfile.idNumber).subscribe({
      next: (idInUse: boolean) => {
        this.idNumberInUse = idInUse;
      },
      error: (error) => {
        this.parseAndDisplayError(error);
      },
    });
  }

  private isTradingPausedReasonMissing(): boolean {
    return this.userProfile.tradingPaused && !this.userProfile.tradingPausedReason?.trim();
  }

  private shouldCheckIdNumber(): boolean {
    if (this.userProfile.idNumber.length != 13) {
      return false;
    }

    if (this.userIdentifiers.idNumber === this.userProfile.idNumber) {
      //nothing has changed, don't check
      return false;
    }

    return true;
  }

  switchTabs(tabName: string) {
    this.currentTab = tabName;
  }
}
